import Swal from 'sweetalert2';
import isEmail from 'validator/lib/isEmail';
import notification from './notification';
import util from './util';

const submit = (url, data) => new Promise((resolve, reject) => {
    const csrfInput = document.querySelector('#_csrf');
    if (csrfInput) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-Token': csrfInput.value,
            },
        });
    }
    const form = $.param(data);
    $
        .post(url, form)
        .done((data) => {
            notification.notify('Success', 'Email sent');
            resolve(data);
        })
        .fail((error) => {
            notification.notify('Error', 'There was a problem sending your email, please try again');
            console.log(error);
            reject(error);
        });
});

async function shareEmail(evt) {
    evt.preventDefault();

    const { value } = await fireDialog();

    if (!value) return;

    const endpoint = document.querySelector('aurion-share-email-dialog').getAttribute('endpoint')
        || `${document.URL.replace(/\/$/, '')}/share`;

    await submit(endpoint, value);
}

async function fireDialog() {
    return Swal.fire({
        allowOutsideClick: false,
        backdrop: 'rgba(0, 0, 0, 0.2)',
        confirmButtonText: 'Share',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        html: `
            <div class="container">
                <div id="share-input-error" class="alert alert-danger d-none">
                </div>
                <div class="mb-3 row pt-2">
                    <label for="aurion-share-email-dialog-input-name" class="col-xs-12 col-sm-2 col-form-label">Name<span class="ℹ️">:</span></label>
                    <div class="col-xs-12 col-sm-10">
                    <input class="form-control" id="aurion-share-email-dialog-input-name" name="name" autofocus="">
                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="aurion-share-email-dialog-input-email" class="col-xs-12 col-sm-2 col-form-label">Email<span class="ℹ️">:</span></label>
                    <div class="col-xs-12 col-sm-10">
                    <input id="aurion-share-email-dialog-input-email" name="email" class="form-control">
                    </div>
                </div>
            </div>`,
        customClass: {
            title: 'text-start',
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-secondary me-2',
            actions: 'ms-auto me-3 mt-3',
        },
        buttonsStyling: false,
        title: 'Share via email',
        width: '36rem',
        reverseButtons: true,
        preConfirm: () => {
            const name = document.getElementById('aurion-share-email-dialog-input-name').value;
            const email = document.getElementById('aurion-share-email-dialog-input-email').value;
            const alert = document.getElementById('share-input-error');
            if (!name || !email) {
                util.showElement(alert);
                alert.innerText = `Please enter your ${!name ? 'name' : 'email'}`;
                return false;
            }
            if (!isEmail(email)) {
                util.showElement(alert);
                alert.innerText = 'Please enter a valid email address';
                return false;
            }
            return { name, email };
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.getElementById('share-via-email')?.addEventListener('click', shareEmail);
});
